import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	getArticleGroups,
	saveArticleGroup,
	updateArticleGroup,
	deleteArticleGroup,
	getArticles,
	saveArticle,
	updateArticle,
	deleteArticle,
} from "services/articleGroup.service";
import { initGlobalState } from "./default";
import { ContType } from "../../common/type";
import { message } from "antd";

const articleSlice = createSlice({
	name: "article",
	initialState: initGlobalState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// Get All asset types
			.addCase(getArticleGroups.pending, (state) => {
				state.getArticleGroupsLoading = true;
			})
			.addCase(getArticleGroups.fulfilled, (state, action) => {
				state.getArticleGroupsLoading = false;
				state.articleGroups = action.payload?.data || [];
			})
			.addCase(getArticleGroups.rejected, (state, action) => {
				state.getArticleGroupsLoading = false;
			})

			// Save Asset type
			.addCase(saveArticleGroup.pending, (state) => {
				state.saveArticleGroupLoading = true;
			})
			.addCase(
				saveArticleGroup.fulfilled,
				(state, action: PayloadAction<ContType>) => {
					const testD: ContType = action.payload;
					state.articleGroups.unshift(testD);
					state.saveArticleGroupLoading = false;
				}
			)
			.addCase(saveArticleGroup.rejected, (state, action) => {
				state.saveArticleGroupLoading = false;
			})

			// Update Institute type
			.addCase(updateArticleGroup.pending, (state) => {
				state.updateArticleGroupLoading = true;
			})
			.addCase(
				updateArticleGroup.fulfilled,
				(state, action: PayloadAction<ContType>) => {
					state.updateArticleGroupLoading = false;
					message.success("Record updated successfully");
					const index = state.articleGroups.findIndex(
						(item) => item.id == action.payload.id
					);
					if (index > -1) {
						state.articleGroups[index] = action.payload;
					}
				}
			)
			.addCase(updateArticleGroup.rejected, (state, action) => {
				state.updateArticleGroupLoading = false;
			})

			// Delete Institute type
			.addCase(deleteArticleGroup.pending, (state) => {
				state.deleteArticleGroupLoading = true;
			})
			.addCase(deleteArticleGroup.fulfilled, (state, action) => {
				state.deleteArticleGroupLoading = false;
				message.success("Record deleted successfully");
				state.articleGroups = state.articleGroups.filter(
					(item) => item.id !== action.meta.arg
				);
			})
			.addCase(deleteArticleGroup.rejected, (state, action) => {
				state.deleteArticleGroupLoading = false;
			})

			// Save Article
			.addCase(saveArticle.pending, (state) => {
				state.saveArticleLoading = true;
			})
			.addCase(saveArticle.fulfilled, (state) => {
				state.saveArticleLoading = false;
				message.success("Record added successfully");
			})
			.addCase(saveArticle.rejected, (state) => {
				state.saveArticleLoading = false;
			})
		
			// Get All Articles
			.addCase(getArticles.pending, (state) => {
				state.articlesLoading = true;
			})
			.addCase(getArticles.fulfilled, (state, action) => {
				state.articlesLoading = false;
				state.articles = action.payload || [];
			})
			.addCase(getArticles.rejected, (state) => {
				state.articlesLoading = false;
			})
		
			// Update Article
			.addCase(updateArticle.pending, (state) => {
				state.updateArticleLoading = true;
			})
			.addCase(updateArticle.fulfilled, (state, action) => {
				state.updateArticleLoading = false;
				message.success("Record updated successfully");
					const index = state.articles.findIndex(
						(item) => item.id == action.payload.id
					);
					if (index > -1) {
						state.articles[index] = action.payload;
					}
			})
			.addCase(updateArticle.rejected, (state) => {
				state.updateArticleLoading = false;
			})
		
			// Delete Article
			.addCase(deleteArticle.pending, (state) => {
				state.deleteArticleLoading = true;
			})
			.addCase(deleteArticle.fulfilled, (state, action) => {
				state.deleteArticleLoading = false;
				message.success("Record deleted successfully");
				state.articles = state.articles.filter(
					(item) => item.id !== action.meta.arg
				);
			})
			.addCase(deleteArticle.rejected, (state, action) => {
				state.deleteArticleLoading = false;
			})
	},
});

export const {} = articleSlice.actions;

export default articleSlice.reducer;
